import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

export const FMT = "YYYY-MM-DD";
export const UPCOMING_WINDOW_MONTHS = 1;
export const RECENT_WINDOW_DAYS = 30;

export const parseD = (v) => {
  if (!v) return dayjs(null);

  // handle [YYYY, MM, DD]
  if (Array.isArray(v) && v.length === 3) {
    const [y, m, d] = v;
    // use UTC to avoid TZ offset causing day -/+ 1
    return dayjs(new Date(Date.UTC(Number(y), Number(m) - 1, Number(d))));
  }

  // handle common string formats
  return dayjs(v, ["YYYY-MM-DD", "YYYY.MM.DD"], true);
};

export const fmtDE = (v) => {
  const d = parseD(v);
  return d.isValid() ? d.format("DD.MM.YYYY") : "-";
};

export const calcNextInspectionDate = (lastStr, freqYears) => {
  if (!lastStr || !freqYears || freqYears <= 0) return null;
  const last = parseD(lastStr);
  if (!last.isValid()) return null;
  return last.add(freqYears, "year").format(FMT);
};

function parseDateToYMD(dateStr) {
  if (dateStr == null || dateStr === undefined || dateStr === '')
    return null;
  else {
    const [day, month, year] = dateStr.split('.').map(Number);
    return [year, month, day];
  }
}


export const getStatus = ({ nextStr, reinspectionStr }) => {
  const today = dayjs().startOf("day");
  const next = parseD(nextStr); // your existing helper

  if (!next.isValid()) return "na";

  const reinspection = parseD(parseDateToYMD(reinspectionStr));

  if (today.isAfter(next, "day")) {
    return "overdue";          // next inspection in the past
  }

  const monthsUntilNext = next.diff(today, "month", true);

  if (monthsUntilNext <= UPCOMING_WINDOW_MONTHS) {
    return "upcoming";         // next inspection in near future
  }

  if (reinspection.isValid()) {
    if (reinspection.isBefore(today, "day")) {
      return "overdue";        // reinspection date in the past
    }
    return "pending";          // reinspection today or in the future
  }

  return "completed";          // next inspection in far future
};


